import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { accountService } from '../../_services';
import moment from 'moment';
function List({ history, match }) {
  const { path } = match;

  let { searchstring } = useParams();

  const [reservations, setReservations] = useState(null);

  useEffect(() => {
    accountService.getAdminReservations(searchstring).then(x => setReservations(x));
  }, [searchstring]);

  function deleteReservation(id) {
    setReservations(reservations.map(x => {
      if (x.id === id) { x.isDeleting = true; }
      return x;
    }));
    accountService.deleteReservation(id).then(() => {
      setReservations(reservations => reservations.filter(x => x.id !== id));
    });
  }

  function bool_display(boolStr) {
    return (boolStr == "True" || boolStr == "true") ? "Y" : "N";
  }

  return (
    <div className="card admin-top-rad bdr-0 admin-btm-rad">
      <h2 className="card-header header-admin">Reservations Admin</h2>
      <Table className="table table-striped" responsive="lg">
        <thead>
          <tr>
            <th >Email</th>
            <th ></th>
            <th >Start Date</th>
            {accountService.configValue['multiDay'] === 'true' && <th>End Date</th>}
            <th >Locker Size</th>
            <th >Paid</th>
            <th >Redeemed</th>
            <th >Ended</th>
            <th >Refunded</th>
            <th> Locker # </th>
            <th> Edit </th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          {reservations && reservations.map(reservation =>
            <React.Fragment key={reservation.id}>
              <tr className="admin-top-bdrline">
                <td colSpan="2" style={{ whiteSpace: 'nowrap' }} ><b>{reservation.accountEmail}</b></td>
                <td colSpan="1" style={{ whiteSpace: 'nowrap' }} ><b>{reservation.startDate}</b></td>
                {accountService.configValue['multiDay'] === 'true' && (
                    <td colSpan="1" style={{ whiteSpace: 'nowrap' }}>
                              <b>{moment(reservation.endDate).add(-1, 'days').format("YYYY-MM-DD")}</b>
                    </td>
                )}
                <td colSpan="1" className="word-break"><b>{reservation.lockerType}</b></td>
                <td colSpan="1" style={(reservation.isPaid.toString() == "true") ? { color: 'green', fontWeight: 'bold' } :
                  { color: 'red', fontWeight: 'bold' }} >
                  {bool_display(reservation.isPaid.toString())}
                </td>
                <td colSpan="1" style={(reservation.isRedeemed.toString() == "true") ? { color: 'green', fontWeight: 'bold' } :
                  { color: 'red', fontWeight: 'bold' }} >
                  {bool_display(reservation.isRedeemed.toString())}
                </td>
                <td colSpan="1" style={(reservation.isEnded.toString() == "true") ? { color: 'green', fontWeight: 'bold' } :
                  { color: 'red', fontWeight: 'bold' }} >
                  {bool_display(reservation.isEnded.toString())}
                </td>
                <td colSpan="1" style={(reservation.isRefunded.toString() == "true") ? { color: 'green', fontWeight: 'bold' } :
                  { color: 'red', fontWeight: 'bold' }} >
                  {bool_display(reservation.isRefunded.toString())}
                </td>
                <td colSpan="1" className="word-break">{reservation.lockerGuiAdmin}</td>
                <td colSpan="2" style={{ whiteSpace: 'nowrap' }}>
                  
                    <Link to={`/admin/reservations/edit_reservation/${reservation.id}`} className="btn btn-sm btn-primary mr-1 blue-btn-edit">Edit</Link>
                  
                </td>
        
              </tr>
            </React.Fragment>
          )}
          {!reservations &&
            <tr>
              <td colSpan="4" className="text-center">
                <span className="spinner-border spinner-border-lg align-center"></span>
              </td>
            </tr>
          }
        </tbody>
      </Table>
      <h3 className="card-header admin-top-bdrline">
        <Link to={`/admin/reservations`} className="btn btn-link">Back</Link>
      </h3>
      <h4>To change size, refund and re-purchase reservation. </h4>

    </div>
  );
}

export { List };